// removed by extract-text-webpack-plugin
module.exports = {"textareaWrapper":"index__textareaWrapper___1ctI5","preview":"index__preview___QiStU"};


//////////////////
// WEBPACK FOOTER
// ./modules/components/TextareaWithPreview/index.css
// module id = 647
// module chunks = 0